// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
import { FaFacebook, FaFacebookMessenger } from 'react-icons/fa';

const Footer = () => {
  const [categories, setCategories] = useState([]);

  const getDepartmentPath = (mainCategoryName) => {
    switch (mainCategoryName) {
      case 'الرجال': return 'men';
      case 'النساء': return 'women';
      case 'الأطفال': return 'children';
      default: return 'men';
    }
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data, error } = await supabase.from('categories').select('id, name, parent_id').order('id');
        if (error) throw error;
        const mainCats = data.filter(cat => cat.parent_id === null);
        const tree = mainCats.map(main => ({ ...main, sub: data.filter(sub => sub.parent_id === main.id) }));
        setCategories(tree);
      } catch (err) {
        console.error('Error fetching footer categories:', err);
      }
    };
    fetchCategories();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box component="footer" sx={{ bgcolor: '#f5f5f5', p: 6 }}>
      {/* Categories Grid */}
      <Box sx={{ maxWidth: '1400px', mx: 'auto', display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 4 }}>
        {categories.map(cat => (
          <Box key={cat.id}>
            <Typography variant="subtitle1" sx={{ fontSize: '20px', fontWeight: 'bold', color: '#0f3662', mb: 1 }}>{cat.name}</Typography>
            {cat.sub.map(sub => (
              <MuiLink key={sub.id}
                component={RouterLink}
                to={`/department/${getDepartmentPath(cat.name)}/${encodeURIComponent(sub.name)}`}
                onClick={scrollToTop}
                underline="none"
                display="block"
                sx={{ fontSize: '16px', fontWeight: 'medium', color: '#a72c2a', mb: 0.5, textAlign: 'right', '&:hover': { color: '#0f3662' } }}
              >{sub.name}</MuiLink>
            ))}
          </Box>
        ))}
      </Box>

      {/* Contact Row */}
      <Box sx={{ maxWidth: '1400px', mx: 'auto', mt: 6, py: 2, display: 'flex', justifyContent: 'space-between', flexDirection: 'row-reverse', alignItems: 'center', borderTop: '2px solid #a72c2a', borderBottom: '2px solid #a72c2a' }}>
        {/* Icons on the left with separate links and spacing */}
        <Box display="flex" alignItems="center" sx={{ gap: 2 }}>
          <MuiLink
            href="https://www.facebook.com/messages/t/110699824870937"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none' }}
          >
            <FaFacebookMessenger  
              size="2rem" 
              color="#0f3662" 
              style={{ backgroundColor: '#f5f5f5', padding: '0.3rem', borderRadius: '50%', border: '2px solid #a72c2a' }} 
            />
          </MuiLink>
          <MuiLink
            href="https://www.facebook.com/profile.php?id=100083343109176"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ textDecoration: 'none' }}
          >
            <FaFacebook
              size="2rem" 
              color="#0f3662" 
              style={{ backgroundColor: '#f5f5f5', padding: '0.3rem', borderRadius: '50%', border: '2px solid #a72c2a' }}  
            />
          </MuiLink>
        </Box>

        {/* Label on the right */}
        <Typography variant="subtitle1" sx={{ fontSize: '22px', fontWeight: 'bold', color: '#333' }}>
          تواصل معنا
        </Typography>
      </Box>

      {/* Footer Bottom */}
      <Box sx={{ textAlign: 'center', mt: 4 }}>
        A to Z Store © {new Date().getFullYear()}
      </Box>
    </Box>
  );
};

export default Footer;
